import React, {useState, useEffect} from "react";
import {getAPI, getSpAPI, inactivateRefreshToken, postAPI} from "./APIUtil";
import {AUTHORIZATION_SERVER} from "./Const";

export const CONST_EXPENSE_CL_TAX_10 = 70;
export const CONST_EXPENSE_CL_TAX_08 = 71;
export const CONST_EXPENSE_CL_TAX_EXEMPT = 72;
export const CONST_EXPENSE_CL_TAX_NON_TAX = 73;

export const CONST_TAX_EXP_10 = 171;
export const CONST_TAX_EXP_08 = 170;
export const CONST_TAX_INC_10 = 271;
export const CONST_TAX_INC_08 = 270;
export const CONST_TAX_EXEMPT = 72;
export const CONST_TAX_NON_TAX = 73;

export const CONST_REMARK_CD_TATEKAE_KEIHI = "00";

export function parseLocationSearch(search) {
  if (!search) {
    return search;
  }

  if (search.substr(0, 1) === '?') {
    search = search.substr(1);
  }
  let params = search.split("&");
  let ret = {};
  for (let i = 0; i < params.length; i++) {
    let p = params[i].split("=");
    ret[p[0]] = p[1];
  }
  return ret;
}

export function useDebounce(value, delay, setLocPage) {
  // debounce の対象 state と setter
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // delay 後 debounce の対象 state をアップデート
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      // setLocPage(1);
    }, delay);

    // 次の effect が実行される直前に timer キャンセル
    return () => {
      clearTimeout(timer);
    };

    // value、delay がアップデートするたびに effect 実行
  }, [value, delay]);

  // 最終的にアップデートされた state をリターン
  return debouncedValue;
}

export function linkFormatter(cell, row, onClickEvent) {
  return (<div><a onClick={() => onClickEvent(row.const_id)}>{cell}</a></div>);
}

// export function amountFormatter(cell, row) {
//   if (cell) {
//     if (!isNaN(cell)) {
//       return (<span>{Intl.NumberFormat().format(cell)}</span>);
//     } else {
//       return (<span>{cell}</span>);
//     }
//   } else {
//     return (<span></span>);
//   }
// }
//
// export function qtyFormatetr(cell, row, digit) {
//   if (cell) {
//     if (!isNaN(cell)) {
//       let s = String(cell);
//       if (s.split(".").length > 1) {
//         let d = s.split(".")[1];
//         while (d.substring(d.length - 1, d.length) === "0" && d.length > 1) {
//           d = d.substring(0, d.length - 1);
//         }
//         digit = d.length;
//       }
//       return (<span>{parseFloat(cell).toFixed(digit)}</span>);
//     } else {
//       return (<span>{cell}</span>);
//     }
//   } else {
//     return (<span></span>);
//   }
// }

export function amountFormatter(value, nullValue = null) {
  if (value) {
    value = String(value).replaceAll(",", "");
    value = Number(value);
    if (!isNaN(value)) {
      return Intl.NumberFormat().format(value);
    } else {
      return value;
    }
  } else {
    return nullValue ? nullValue : value;
  }
}

export function parseDigit(cell, digit) {
  if (cell) {
    if (!isNaN(cell)) {
      let s = String(cell);
      if (s.split(".").length > 1) {
        let d = s.split(".")[1];
        while (d.substring(d.length - 1, d.length) === "0" && d.length > 1) {
          d = d.substring(0, d.length - 1);
        }
        digit = d.length;
      }
      return parseFloat(cell).toFixed(digit);
    } else {
      return cell;
    }
  }
}

export function resultFormatter(cell, row) {
  return (<span></span>);
}

export function dateformat(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" + dateObj.getDate()).slice(-2);
    return year + "-" + month + "-" + date;
  }
  return "";
}

export function dateformatYYYYMMDD(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" + dateObj.getDate()).slice(-2);
    return "" + year + month + date;
  }
  return "";
}

export function dateformatYYYYMM(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    return "" + year + month;
  }
  return "";
}

export function dateformatYYYY_MM(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    return "" + year + "-" + month;
  }
  return "";
}

export function dateformatYYYY_MM_DD(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" +  dateObj.getDate()).slice(-2);
    return "" + year + "-" + month + "-" + date;
  }
  return "";
}

export function dateformatYYYYMMDDHHMMSS(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" + dateObj.getDate()).slice(-2);
    let hours = ("0" + dateObj.getHours()).slice(-2);
    let minutes = ("0" + dateObj.getMinutes()).slice(-2);
    let seconds = ("0" + dateObj.getSeconds()).slice(-2);
    return "" + year + month + date + hours + minutes + seconds;
  }
  return "";
}

export function parseDate(strDate) {
  if (strDate) {
    let date = new Date();
    if (strDate.length === 6) {
      date = new Date(parseInt(strDate.substr(0, 4)), parseInt(strDate.substr(4, 2)) - 1, 1);
    } else if (strDate.length === 8) {
      date = new Date(parseInt(strDate.substr(0, 4)), parseInt(strDate.substr(4, 2)) - 1, parseInt(strDate.substr(6, 2)));
    } else if (strDate.length === 10) {
      date = new Date(parseInt(strDate.substr(0, 4)), parseInt(strDate.substr(5, 2)) - 1, parseInt(strDate.substr(8, 2)));
    } else if (strDate.length === 11) {
      date = new Date(parseInt(strDate.substr(0, 4)), parseInt(strDate.substr(5, 2)) - 1, parseInt(strDate.substr(8, 2)));
    } else {
      let timestamp = Date.parse(strDate);
      if (isNaN(timestamp) == false) {
        date = new Date(timestamp);
      }
    }
    return date;
  }
}

export function parseDatetime(strDatetime) {
  if (strDatetime) {
    //YYYY-MM-DD HH:MM:SS形式
    if (strDatetime.length === 19) {
      let date = new Date(
        parseInt(strDatetime.substr(0, 4)),
        parseInt(strDatetime.substr(5, 2)) - 1,
        parseInt(strDatetime.substr(8, 2)),
        parseInt(strDatetime.substr(11, 2)),
        parseInt(strDatetime.substr(14, 2)),
        parseInt(strDatetime.substr(17, 2))
      );
      return date;
    }
    return new Date();
  }
}

export function dateformatJPN(dateObj) {

  if (!dateObj) {
    return "";
  }

  const weekday = ['日', '月', '火', '水', '木', '金', '土'];
  let year = dateObj.getFullYear();
  let month = (dateObj.getMonth() + 1);
  let date = dateObj.getDate();
  let week = weekday[dateObj.getDay()];
  return year + "年" + month + "月" + date + "日（" + week + "）";
}

export function dateformatJPNYYYYMMDD(dateObj) {

  if (!dateObj) {
    return "";
  }

  let year = dateObj.getFullYear();
  let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  let date = ("0" + dateObj.getDate()).slice(-2);
  return year + "年" + month + "月" + date + "日";
}

export function dateformatJPNYYMMDD(dateObj) {

  if (!dateObj) {
    return "";
  }

  let year = dateObj.getFullYear();
  year = ("" + year).substring(2);
  let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  let date = ("0" + dateObj.getDate()).slice(-2);
  return year + "年" + month + "月" + date + "日";
}

export function dateformatJPNMMDD(dateObj) {

  if (!dateObj) {
    return "";
  }

  let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  let date = ("0" + dateObj.getDate()).slice(-2);
  return month + "月" + date + "日";
}

export function dateformatJPNByType(dateObj, type) {

  if (!dateObj) {
    return "";
  }

  const weekday = ['日', '月', '火', '水', '木', '金', '土'];
  const weekdayEng = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  if ("year" === type) {
    return dateObj.getFullYear();
  } else if ("month" === type) {
    return (dateObj.getMonth() + 1);
  } else if ("date" === type) {
    return dateObj.getDate();
  } else if ("hours" === type) {
    return dateObj.getHours();
  } else if ("minutes" === type) {
    return dateObj.getMinutes();
  } else if ("second" === type) {
    return dateObj.getSeconds();
  } else if ("dateOfWeek" === type) {
    return weekday[dateObj.getDay()];
  } else if ("dateOfWeekEng" === type) {
    return weekdayEng[dateObj.getDay()];
  }
  return "";
}

export function dateformatDB(dateObj) {
  if (dateObj instanceof Date) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" + dateObj.getDate()).slice(-2);
    return year + "-" + month + "-" + date;
  }
  return dateObj;
}

export function datetimeformatDB(dateObj) {
  if (dateObj) {
    let year = dateObj.getFullYear();
    let month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    let date = ("0" + dateObj.getDate()).slice(-2);

    let hours = ("0" + dateObj.getHours()).slice(-2);
    let minutes = ("0" + dateObj.getMinutes()).slice(-2);
    let seconds = ("0" + dateObj.getSeconds()).slice(-2);
    return year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  }
  return dateObj;
}

export function timeformatHHMM(timeStr) {
  if (timeStr) {
    return timeStr.substr(0, 5);
  }
  return timeStr;
}

export const dateformatDatePicker = (value) => {
  if (!value) {
    return null;
  }
  value = value.replaceAll("-", "");
  value = value.replaceAll("/", "");
  value = value.replaceAll("年", "");
  value = value.replaceAll("月", "");
  value = value.replaceAll("日", "");
  value = toSingleByte(value);
  if (value.length === 1) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 1)) - 1, 1);
  }
  if (value.length === 2) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 2)) - 1, 1);
  }
  if (value.length === 6) {
    return new Date(value.substring(0, 4), parseInt(value.substring(4, 6)) - 1, 1);
  }
  if (value.length === 8) {
    return new Date(value.substring(0, 4), parseInt(value.substring(4, 6)) - 1, value.substring(6, 8));
  }
  if (value.length === 4) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 2)) - 1, value.substring(2, 4));
  }
  if (value.substring(4, 5) === "年" && value.substring(7, 8) === "月" && value.substring(10, 11) === "日") {
    return new Date(value.substring(0, 4), parseInt(value.substring(5, 7)) - 1, value.substring(8, 10));
  }
  return null;
}

export const dateformatDatePickerYYYYMM = (value) => {
  if (!value) {
    return null;
  }
  value = value.replaceAll("-", "");
  value = value.replaceAll("/", "");
  value = value.replaceAll("年", "");
  value = value.replaceAll("月", "");
  value = value.replaceAll("日", "");
  value = toSingleByte(value);
  if (value.length === 1) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 1)) - 1, 1);
  }
  if (value.length === 2) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 2)) - 1, 1);
  }
  if (value.length === 6) {
    return new Date(value.substring(0, 4), parseInt(value.substring(4, 6)) - 1, 1);
  }
  if (value.length === 8) {
    return new Date(value.substring(0, 4), parseInt(value.substring(4, 6)) - 1, value.substring(6, 8));
  }
  if (value.length === 4) {
    return new Date(new Date().getFullYear(), parseInt(value.substring(0, 2)) - 1, value.substring(2, 4));
  }
  if (value.substring(4, 5) === "年" && value.substring(7, 8) === "月" && value.substring(10, 11) === "日") {
    return new Date(value.substring(0, 4), parseInt(value.substring(5, 7)) - 1, value.substring(8, 10));
  }
  return null;
}

export function nvl(val, replaceValue = "") {
  if (val == null) {
    return replaceValue
  }
  return val;
}

export function toNull(val) {
  if ("" === val) {
    return null;
  }
  return val;
}

export function setFocusCalendar(e, id) {
  e.preventDefault();
  $("#" + id).focus();
}

export const onSearchTime = async (query) => {
  let time = [
    {name: '00:00', id: '00:00'},
    {name: '00:15', id: '00:15'},
    {name: '00:30', id: '00:30'},
    {name: '00:45', id: '00:45'},
    {name: '01:00', id: '01:00'},
    {name: '01:15', id: '01:15'},
    {name: '01:30', id: '01:30'},
    {name: '01:45', id: '01:45'},
    {name: '02:00', id: '02:00'},
    {name: '02:15', id: '02:15'},
    {name: '02:30', id: '02:30'},
    {name: '02:45', id: '02:45'},
    {name: '03:00', id: '03:00'},
    {name: '03:15', id: '03:15'},
    {name: '03:30', id: '03:30'},
    {name: '03:45', id: '03:45'},
    {name: '04:00', id: '04:00'},
    {name: '04:15', id: '04:15'},
    {name: '04:30', id: '04:30'},
    {name: '04:45', id: '04:45'},
    {name: '05:00', id: '05:00'},
    {name: '05:15', id: '05:15'},
    {name: '05:30', id: '05:30'},
    {name: '05:45', id: '05:45'},
    {name: '06:00', id: '06:00'},
    {name: '06:15', id: '06:15'},
    {name: '06:30', id: '06:30'},
    {name: '06:45', id: '06:45'},
    {name: '07:00', id: '07:00'},
    {name: '07:15', id: '07:15'},
    {name: '07:30', id: '07:30'},
    {name: '07:45', id: '07:45'},
    {name: '08:00', id: '08:00'},
    {name: '08:15', id: '08:15'},
    {name: '08:30', id: '08:30'},
    {name: '08:45', id: '08:45'},
    {name: '09:00', id: '09:00'},
    {name: '09:15', id: '09:15'},
    {name: '09:30', id: '09:30'},
    {name: '09:45', id: '09:45'},
    {name: '10:00', id: '10:00'},
    {name: '10:15', id: '10:15'},
    {name: '10:30', id: '10:30'},
    {name: '10:45', id: '10:45'},
    {name: '11:00', id: '11:00'},
    {name: '11:15', id: '11:15'},
    {name: '11:30', id: '11:30'},
    {name: '11:45', id: '11:45'},
    {name: '12:00', id: '12:00'},
    {name: '12:15', id: '12:15'},
    {name: '12:30', id: '12:30'},
    {name: '12:45', id: '12:45'},
    {name: '13:00', id: '13:00'},
    {name: '13:15', id: '13:15'},
    {name: '13:30', id: '13:30'},
    {name: '13:45', id: '13:45'},
    {name: '14:00', id: '14:00'},
    {name: '14:15', id: '14:15'},
    {name: '14:30', id: '14:30'},
    {name: '14:45', id: '14:45'},
    {name: '15:00', id: '15:00'},
    {name: '15:15', id: '15:15'},
    {name: '15:30', id: '15:30'},
    {name: '15:45', id: '15:45'},
    {name: '16:00', id: '16:00'},
    {name: '16:15', id: '16:15'},
    {name: '16:30', id: '16:30'},
    {name: '16:45', id: '16:45'},
    {name: '17:00', id: '17:00'},
    {name: '17:15', id: '17:15'},
    {name: '17:30', id: '17:30'},
    {name: '17:45', id: '17:45'},
    {name: '18:00', id: '18:00'},
    {name: '18:15', id: '18:15'},
    {name: '18:30', id: '18:30'},
    {name: '18:45', id: '18:45'},
    {name: '19:00', id: '19:00'},
    {name: '19:15', id: '19:15'},
    {name: '19:30', id: '19:30'},
    {name: '19:45', id: '19:45'},
    {name: '20:00', id: '20:00'},
    {name: '20:15', id: '20:15'},
    {name: '20:30', id: '20:30'},
    {name: '20:45', id: '20:45'},
    {name: '21:00', id: '21:00'},
    {name: '21:15', id: '21:15'},
    {name: '21:30', id: '21:30'},
    {name: '21:45', id: '21:45'},
    {name: '22:00', id: '22:00'},
    {name: '22:15', id: '22:15'},
    {name: '22:30', id: '22:30'},
    {name: '22:45', id: '22:45'},
    {name: '23:00', id: '23:00'},
    {name: '23:15', id: '23:15'},
    {name: '23:30', id: '23:30'},
    {name: '23:45', id: '23:45'},
  ];

  let locOptions = [];
  time.map((result) => {
    if (query.length === 0 || result.name.indexOf(query) >= 0) {
      locOptions.push({name: result.name, id: result.id});
    }
  });
  return locOptions;
}

export const jumpToTopByDevice = (history) => {
  // if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
  //   if(location.pathname.indexOf("mb_") < 0){
  //     history.push("/mb_top");
  //   }
  // } else {
  //     history.push("/");
  // }
}

export const getDownloadFileName = (contentDisposition) => {

  let fileName = contentDisposition.substring(
    contentDisposition.indexOf("filename=") + 9,
    contentDisposition.length
  );

  fileName = decodeURI(fileName).replace(/\+/g, " ");
  return fileName;

}

export const isLatestVersion = async (isSp = false) => {

  let url = "version"
  let res = null;
  let device = null;

  if (!isSp) {
    res = await getAPI(url);
    device = "pc";
  } else {
    res = await getSpAPI(url)
    device = "sp";
  }

  let localStorageVersion = localStorage.getItem("const_manager_version_" + device);
  if (res.version != localStorageVersion) {
    console.log("更新:" + localStorageVersion + " >> " + res.version);
    localStorage.setItem("const_manager_version_" + device, res.version);
    localStorage.removeItem("storage_pic_list");
    localStorage.removeItem("storage_pic_file_name");
    localStorage.removeItem("storage_pic_file_info");

    localStorage.removeItem("book_search_condition");
    localStorage.removeItem("const_search_condition");
    localStorage.removeItem("cal_search_condition");
    localStorage.removeItem("design_search_condition");
    localStorage.removeItem("doc_search_condition");

    window.location.reload(true);
  }

}

export const getVersion = (isSp = false) => {

  let device = null;
  if (!isSp) {
    device = "pc";
  } else {
    device = "sp";
  }
  return localStorage.getItem("const_manager_version_" + device);

}

export const logout = async (isSp = false) => {

  await inactivateRefreshToken();
  localStorage.removeItem("const_manager_token");
  window.location = location.protocol + "//" + AUTHORIZATION_SERVER + (!isSp ? "" : "/sp") + "/auth/";

}

export const lpad = (val, digits, char) => {

  if (!val) {
    return val;
  } else {
    val = String(val);
  }

  while (getVisualLength(val) < digits) {
    val = char + val;
  }

  return val;
}

export const rpad = (val, digits, char) => {

  if (!val) {
    val = "";
  } else {
    val = String(val);
  }

  while (getVisualLength(val) < digits) {
    val = val + char;
  }
  return val;
}

export const getVisualLength = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    const ch = str.charAt(i);
    if(ch === '\u00a0') {
      // ノーブレークスペースは半角1文字でカウント
      len += 1;
    }else if ((c >= 0x01 && c <= 0x7E) || (c >= 0xA1 && c <= 0xDF) || (c >= 0xFF61 && c <= 0xFF9F)) {
      // 半角: ASCII (0x01-0x7E), 半角カナ (0xA1-0xDF)
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

export const addField = (obj, fieldName, value) => {

  if (!fieldName) {
    return obj;
  }
  if (value === null || value === undefined || value === '') {
    return obj;
  }
  obj[fieldName] = value;
  return obj;

}

// ファイルユーティリティ ////////////////////////////////////////////////////////
export const getDocType = (fileName) => {
  if (fileName.split('.').length > 0) {
    return fileName.split('.').pop();
  }
  return "";
}

export const getDocName = (fileName) => {
  return fileName.substr(0, fileName.lastIndexOf("."));
}

//住所補完＆自動セット
export const formatZip = async (zip, callbackSetZip, callbackSetPref = null, callbackSetPrefSelected = null, callbackSetCity = null) => {

  if (!zip) {
    return;
  }

  if (zip.length != 7 || !zip.match(/^[0-9]+$/)) {
    return;
  }

  zip = zip.substr(0, 3) + "-" + zip.substr(3, 4);
  setZipAuto(zip, callbackSetZip, callbackSetPref, callbackSetPrefSelected, callbackSetCity);

}

//住所自動セット
export const setZipAuto = async (zip, callbackSetZip, callbackSetPref, callbackSetPrefSelected, callbackSetCity) => {

  callbackSetZip(toSingleByte(zip));

  if (!zip) {
    return;
  }
  if (zip.length !== 8) {
    return;
  }
  const res = await fetch("https://zipcloud.ibsnet.co.jp/api/search?zipcode=" + zip, {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  });
  let json = await res.json();
  if (!json.results) {
    return;
  }
  if (callbackSetPref) {
    callbackSetPref(json.results[0].address1);
  }
  if (callbackSetPrefSelected) {
    callbackSetPrefSelected({name: json.results[0].address1, id: json.results[0].address1});
  }
  if (callbackSetCity) {
    callbackSetCity(json.results[0].address2 + json.results[0].address3);
  }
}

//住所補完＆自動セット
export const formatTimeHHMM = (time) => {

  if (!time) {
    return time;
  }

  time = toSingleByte(time);

  //0-9と:のみにする
  let times = time.split('');
  time = '';
  for (let i = 0; i < times.length; i++) {
    if (times[i].match(/[0-9\:]/)) {
      time += times[i];
    }
  }

  if (time.length < 3) {
    return "";
  }

  if (time.length === 5) {
    return time;
  }

  time = time.replaceAll(":", "");
  time = ("00" + time).slice(-4);
  time = time.substr(0, 2) + ":" + time.substr(2, 2);
  return time;
}

//次ステータス取得 承認
export const nextStatusByApprove = (status) => {
  if (status === '新規') {
    return '上長承認中';
  } else if (status === '上長承認中') {
    return '副社長承認中';
  } else if (status === '副社長承認中') {
    return '社長承認中';
  } else if (status === '社長承認中') {
    return '支払前';
  } else if (status === '支払前') {
    return '支払済';
  }
  return null;
}

//次ステータス取得 差し戻し
export const nextStatusByReject = (status) => {
  if (status === '上長承認中') {
    return '新規';
  } else if (status === '副社長承認中') {
    return '上長承認中';
  } else if (status === '社長承認中') {
    return '副社長承認中';
  } else if (status === '支払前') {
    return '社長承認中';
  }
  return null;
}

export const dispCommorancyCl = (val) => {
  if (val === 1) {
    return "1 国内";
  }
  if (val === 2) {
    return "2 海外";
  }
}

export const dispConsumptionTax = (val) => {
  if (val === 0) {
    return "0 標準";
  }
  if (val === 1) {
    return "1 内税";
  }
  if (val === 2) {
    return "2 外税";
  }
  if (val === 1) {
    return "3 非課税";
  }
}

export const dispRoundingOffCl = (val) => {
  if (val === 0) {
    return "0 標準";
  }
  if (val === 1) {
    return "1 四捨五入";
  }
  if (val === 2) {
    return "2 切り上げ";
  }
  if (val === 1) {
    return "3 切り捨て";
  }
}

export const dispWithholdingObjectCl = (val) => {
  if (val === 1) {
    return "1 対象外";
  }
  if (val === 2) {
    return "2 対象（国内）";
  }
  if (val === 1) {
    return "3 対象（海外）";
  }
}

export const dispPayGrpStatus = (payGrpObj) => {

  if (payGrpObj.pay_finalize_date) {
    return "支払済";
  }
  if (payGrpObj.acc_data_create_date) {
    return "処理中";
  }
  if (payGrpObj.fb_data_create_date) {
    return "処理中";
  }
  if (payGrpObj.pay_notice_create_date) {
    return "処理中";
  }
  if (payGrpObj.exp_tran_create_date) {
    return "処理中";
  }
  return "支払前";
}

export const getPayGrpStatusNo = (payGrpObj) => {

  if (payGrpObj.pay_finalize_date) {
    return "90";
  }
  if (payGrpObj.acc_data_create_date) {
    return "30";
  }
  if (payGrpObj.fb_data_create_date) {
    return "30";
  }
  if (payGrpObj.pay_notice_create_date) {
    return "30";
  }
  if (payGrpObj.exp_tran_create_date) {
    return "30";
  }

  if (payGrpObj === "処理中") {
    return "30";
  }
  if (payGrpObj === "支払済") {
    return "90";
  }

  return "01";
}

export const R_ROUND = 2;
export const R_CEIL = 3;
export const R_FLOOR = 4;
export const r = (val, cutoff, digits) => {

  val = val * Math.pow(10, digits);
  if (cutoff === 2) {
    // 四捨五入
    val = Math.round(val);
  }
  if (cutoff === 3) {
    // 切り上げ
    val = Math.ceil(val);
  }
  if (cutoff === 4) {
    // 切り捨て
    val = Math.floor(val);
  }
  return val / Math.pow(10, digits);
}

// 支払い or 経費
export const isExpense = (expenseCl) => {
  if (expenseCl === CONST_EXPENSE_CL_TAX_10 ||
    expenseCl === CONST_EXPENSE_CL_TAX_08 ||
    expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT ||
    expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX ||
    expenseCl === CONST_TAX_INC_10 ||
    expenseCl === CONST_TAX_INC_08) {
    return true;
  }
  return false;
}

// 内税・外税判定
export const isTaxInclude = (expenseCl) => {
  if (expenseCl === CONST_EXPENSE_CL_TAX_10 ||
    expenseCl === CONST_EXPENSE_CL_TAX_08 ||
    expenseCl === CONST_TAX_INC_10 ||
    expenseCl === CONST_TAX_INC_08) {
    return true;
  }
  return false;
}

// 合計金額の計算
export const calcLineAmount = (price, qty, page) => {
  let cPrice = 0;
  let cTotal = 0;
  if (!price) {
    return null;
  }

  cPrice = parseNumber(price);
  if (isNaN(cPrice)) {
    return null;
  }

  if (!qty && !page) {
    return null;
  }

  if (qty && !isNaN(parseNumber(qty))) {
    cTotal = parseNumber(qty);
  } else if (page && !isNaN(parseNumber(page))) {
    cTotal = parseNumber(page);
  } else {
    return null;
  }

  return cPrice * cTotal;
}

// 消費税の計算
export const calcLineTaxAmount = (expenseCl, cLineAmount) => {
  let taxRate = 0.1;
  if(expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl == CONST_TAX_EXP_08 || expenseCl === CONST_TAX_INC_08){
    taxRate = 0.08;
  }else if(expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl == CONST_EXPENSE_CL_TAX_NON_TAX || expenseCl === CONST_TAX_EXEMPT || expenseCl === CONST_TAX_NON_TAX){
    taxRate = 0;
  }

  // 浮動小数点誤差を避けるため、税率を整数(%)にして計算する（例: 3135 / 1.1 * 0.1 = 284.99999... になる）
  const taxPercent = Math.round(taxRate * 100);
  let taxAmount = 0;
  if(expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_TAX_INC_10 || expenseCl === CONST_TAX_INC_08){
    //内税の場合
    taxAmount = cLineAmount * taxPercent / ( 100 + taxPercent );
  }else{
    //外税の場合
    taxAmount = cLineAmount * taxPercent / 100;
  }

  taxAmount = Math.floor(taxAmount); // 切り捨て
  return taxAmount;
}

// 源泉徴収の計算
export const calcLineWithholdTaxAmount = (lineAmount, withholdingObjectCl, taxClassCd = null, remarkCd = null) => {
  if(withholdingObjectCl === 1){
    //源泉徴収・対象外
    return 0;
  }
  if(remarkCd === CONST_REMARK_CD_TATEKAE_KEIHI){
    //源泉徴収・対象外
    return 0;
  }

  let cWithholdTax = 0;
  if (lineAmount <= 1000000) {
    //100万以下の場合
    cWithholdTax = lineAmount * 0.1021;
  } else {
    //100万を超える分
    cWithholdTax = (lineAmount - 1000000) * 0.2042 + 102100;
  }
  cWithholdTax = Math.floor(cWithholdTax);
  return cWithholdTax;
}

// 入力チェック　/////////////////////////////////
export function checkKey(event, pattern) {
  if (!event.key.match(pattern)) {
    event.preventDefault();
    return;
  }
}

// 全角を半角に変換　/////////////////////////////////
export function toSingleByte(value) {
  value = toSingleByteAlphaNumberOnly(value);
  value = value.replace(/[－﹣‐﹘―⎯⏤ー─━]/g, '-');
  return value;
}

export function toSingleByteAlphaNumberOnly(value) {
  value = "" + value;
  value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  return value;
}

export function toSingleByteNumberOnly(value) {
  value = "" + value;
  value = value.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  return value;
}

// 半角を全角に変換　/////////////////////////////////
export function toMultibyte(value) {
  value = "" + value;
  value = value.replace(/[A-Za-z0-9]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
  });
  value = value.replace(/[-−⁃‑‒–—ｰ]/g, 'ー');
  return value;
}

// 数値用カンマ削除　/////////////////////////////////
export function parseNumber(value) {
  if (!value) {
    return value;
  }
  let val = '' + value;
  val = toSingleByte(value);
  val = val.replace(/,/g, '');
  return parseFloat(val);

}// 数値用カンマ追加　/////////////////////////////////
export function formatNumber(value) {
  if (!value) {
    return value;
  }
  let val = '' + value;
  val = toSingleByte(value);
  val = val.replace(/,/g, '');
  if (val.match(/[^0-9.-]/)) {
    return "";
  }
  val = parseFloat(val).toLocaleString();
  return val;
}

// ボタンローディング開始
export const startLoadingBtn = (id, variant = "primary") => {

  let list = $("#" + id).children("span");
  for (let i = 0; i < list.length; i++) {
    $(list[0]).css("display", "none");
  }
  $("#" + id).append("<img id='img_loading_btn' src='/static/loading_btn_30_" + variant + ".gif' style='margin: 0 auto;height: 20px;'/>");
  $("#" + id).prop("disabled", true);
}

// ボタンローディング終了
export const finishLoadingBtn = (id) => {

  $("#" + id).children("#img_loading_btn").remove();
  let list = $("#" + id).children("span");
  for (let i = 0; i < list.length; i++) {
    $(list[0]).css("display", "block");
  }
  $("#" + id).prop("disabled", false);

}

// スリープ関数
export const sleepByPromise = (sec) => {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

export const onFocusSelect = (e) => {
  $(e.target).select();
}

// export const JS_DEBUG = (o) => {
//   console.log(o);
// }

export const onFocusText = (e) => {
  e.target.select();
}

export const onKeyDownNext = async (e = null, elementId = null) => {

  if (e === null || isEnterKey(e) ||
    e.key === "ArrowDown" || e.key === "ArrowUp") {
    let index = document.activeElement.tabIndex;
    if (elementId) {
      index = document.getElementById(elementId).tabIndex;
    }
    let next = null;
    let upDown = 1; // UP
    if (e !== null) {
      if (e.shiftKey || e.key === "ArrowUp") {
        upDown = -1;
      }
    }
    if (upDown === 1 && e && e.target && e.target.getAttribute("next-tabindex")) {
      next = $("[tabindex='" + e.target.getAttribute("next-tabindex") + "']")[0];
    } else if (upDown === -1 && e && e.target && e.target.getAttribute("prev-tabindex")) {
      next = $("[tabindex='" + e.target.getAttribute("prev-tabindex") + "']")[0];
    } else {
      for (let i = 1; i < 9999; i++) {
        if ($("[tabindex='" + (index + (i * upDown)) + "']:not([disabled])").length > 0) {
          next = $("[tabindex='" + (index + (i * upDown)) + "']")[0];
          break;
        }
      }
    }
    if (!next) {
      return;
    }
    if (e !== null) {
      e.preventDefault();
    }
    await sleepByPromise(0.02);
    next.focus();
  }
}

// 明細セル間を矢印キーで移動する（エクセル風）。移動した場合は true を返す
export const moveCellByArrow = (e) => {
  const key = e.key;
  if (!["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(key)) {
    return false;
  }
  if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) {
    return false;
  }
  const cur = e.target;
  const isText = cur.tagName === "INPUT" || cur.tagName === "TEXTAREA";
  if (isText) {
    const val = cur.value || "";
    const isSelect = !!cur.closest(".async-select");
    if (key === "ArrowLeft" || key === "ArrowRight") {
      if (isSelect) {
        if (val !== "") {
          return false; // 検索文字入力中はカーソル移動を優先
        }
      } else {
        const allSelected = cur.selectionStart === 0 && cur.selectionEnd === val.length;
        const atEdge = key === "ArrowLeft"
          ? (cur.selectionStart === 0 && cur.selectionEnd === 0)
          : (cur.selectionStart === val.length && cur.selectionEnd === val.length);
        if (!allSelected && !atEdge) {
          return false;
        }
      }
    } else if (cur.tagName === "TEXTAREA" && val.indexOf("\n") > -1) {
      return false; // 複数行入力中は行移動を優先
    }
  }

  const cellRect = (el) => (el.closest(".col-editable") || el).getBoundingClientRect();
  const cands = $("input[tabindex], textarea[tabindex]").toArray().filter(el => {
    return el.tabIndex >= 1100 && !el.disabled && el.type !== "hidden" && el.offsetParent !== null;
  });
  const cr = cellRect(cur);
  const curCy = (cr.top + cr.bottom) / 2;
  const tol = 4;

  const items = cands
    .filter(el => el !== cur)
    .map(el => {
      const r = cellRect(el);
      return { el, left: r.left, right: r.right, cy: (r.top + r.bottom) / 2 };
    })
    .filter(o => !(o.left === cr.left && o.right === cr.right && Math.abs(o.cy - curCy) <= tol)); // 同一セル内の別要素を除外

  let next = null;
  if (key === "ArrowLeft" || key === "ArrowRight") {
    const sameRow = items.filter(o => Math.abs(o.cy - curCy) <= cr.height / 2);
    const dir = key === "ArrowRight" ? 1 : -1;
    const side = sameRow.filter(o => dir === 1 ? o.left >= cr.right - 1 : o.right <= cr.left + 1);
    side.sort((a, b) => dir === 1 ? a.left - b.left : b.right - a.right);
    if (side.length > 0) {
      next = side[0].el;
    } else {
      // 行端：右端→次行の一番左、左端→前行の一番右
      const rows = items.filter(o => dir === 1 ? o.cy > curCy + tol : o.cy < curCy - tol);
      if (rows.length > 0) {
        const nearCy = rows.reduce((m, o) => dir === 1 ? Math.min(m, o.cy) : Math.max(m, o.cy), dir === 1 ? Infinity : -Infinity);
        const row = rows.filter(o => Math.abs(o.cy - nearCy) <= Math.max(tol, cr.height / 2));
        row.sort((a, b) => dir === 1 ? a.left - b.left : b.right - a.right);
        next = row[0].el;
      }
    }
  } else {
    const dir = key === "ArrowDown" ? 1 : -1;
    const rows = items.filter(o => dir === 1 ? o.cy > curCy + tol : o.cy < curCy - tol);
    if (rows.length > 0) {
      const nearCy = rows.reduce((m, o) => dir === 1 ? Math.min(m, o.cy) : Math.max(m, o.cy), dir === 1 ? Infinity : -Infinity);
      const row = rows.filter(o => Math.abs(o.cy - nearCy) <= Math.max(tol, cr.height / 2));
      // 左端がそろっている（現在セルの左端を含む）セルを優先
      let hit = row.filter(o => o.left <= cr.left + 1 && o.right > cr.left + 1);
      if (hit.length === 0) {
        hit = row;
      }
      hit.sort((a, b) => Math.abs(a.left - cr.left) - Math.abs(b.left - cr.left));
      next = hit[0].el;
    }
  }

  e.preventDefault();
  if (next) {
    next.focus();
    if (next.tagName === "INPUT" && !next.closest(".async-select")) {
      next.select();
    }
  }
  return true;
}

export const moveFocus = (nextIndex = 1) => {

  let index = document.activeElement.tabIndex;
  for (let i = 1; i < 9999; i++) {
    if ((index + i) < nextIndex) {
      continue;
    }
    if ($("[tabindex='" + (index + i) + "']:not([disabled])").length > 0) {
      moveFocusByTabIndex(index + i);
      break;
    }
  }
}

export const moveFocusBack = () => {

  let index = document.activeElement.tabIndex;
  for (let i = index - 1; i > -9999; i--) {
    if ($("[tabindex='" + i + "']").length > 0) {
      moveFocusByTabIndex(i);
      break;
    }
  }
}

export const moveFocusByTabIndex = (tabIndex) => {
  let next = $("[tabindex='" + tabIndex + "']")[0];
  if (!next) {
    return;
  }
  $(next).prop('disabled', false);
  next.focus();
}

export const onKeyDownNextTextArea = (e = null, elementId = null) => {
  if (e === null || e.key === "Enter") {
    const t = document.activeElement;
    if (t.selectionStart !== t.selectionEnd || t.innerHTML === "") {
      let index = document.activeElement.tabIndex;
      if (elementId) {
        index = document.getElementById(elementId).tabIndex;
      }
      let next = null;
      let upDown = 1; // UP
      if (e !== null) {
        if (e.shiftKey) {
          upDown = -1;
        }
      }
      for (let i = 1; i < 200; i++) {
        if ($("[tabindex='" + (index + i) + "']:not([disabled])").length > 0) {
          next = $("[tabindex='" + (index + (i * upDown)) + "']")[0];
          break;
        }
      }
      if (!next) {
        return;
      }
      if (e !== null) {
        e.preventDefault();
      }
      next.focus();
    }
  }
}

export const onKeyDownShortCut = async (e, ctlShiftEnterHandler = null, ctlEnterHadler = null, escHadler = null, spaceHandler = null, nextHandler = null) => {
  if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && e.shiftKey && ctlShiftEnterHandler) {
    ctlShiftEnterHandler(e);
    return;
  }
  if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && ctlEnterHadler) {
    ctlEnterHadler(e);
    return;
  }
  if (e.key === "Escape" && escHadler) {
    escHadler(e);
    return;
  }
  if (e.key === " " && spaceHandler) {
    spaceHandler(e);
    return;
  }
  if (e.key === "Enter" && nextHandler) {
    nextHandler(e);
    return;
  }
}

export const isEnterKey = (e = null) => {
  if (e.ctrlKey || e.metaKey) {
    return false
  }
  if (e.key === "Enter") {
    return true;
  }
  return false;
}

export const isSubmit = (e = null) => {
  if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
    return true;
  }
  return false;
}

export const focusById = async (id) => {
  await sleepByPromise(0.02);
  const x = window.scrollX;
  const y = window.scrollY;
  $("#" + id).focus();
  $("#" + id).select();
  window.scrollTo(x, y);
}
